import React from "react";
import { Dialog, Divider } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { useNavigate } from "react-router-dom";

import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import { useDispatch } from "react-redux";
import { getCompanyUsers } from "../../redux/company/actions";

const AddPlayerBillingUpdate = ({
  addPlayerBillingDialog,
  closeAddPlayerBillingDialog,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const okayHandler = () => {
    closeAddPlayerBillingDialog();
    dispatch(getCompanyUsers());
  };

  return (
    <Dialog
      open={addPlayerBillingDialog}
      onClose={closeAddPlayerBillingDialog}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "600px",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
          boxShadow:
            "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
          borderRadius: "24px",
          border: "1px solid rgba(255,255,255,0.6)",
          backdropFilter: "blur(18px) saturate(160%)",
        },
      }}
    >
      <SoftBox sx={{ padding: { mini: "1rem", md: "1.5rem" } }}>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <SoftTypography variant="h4" sx={{ color: "#0F172A" }}>
            Billing Update
          </SoftTypography>
          <SoftButton
            variant="outlined"
            color="dark"
            onClick={closeAddPlayerBillingDialog}
            sx={{
              "& svg": { fontSize: "1.25rem !important" },
              borderRadius: "50%",
              minWidth: "max-content",
              minHeight: "max-content",
              padding: "0.25rem",
              color: "#475467",
            }}
          >
            <CloseRoundedIcon />
          </SoftButton>
        </SoftBox>
        <Divider
          sx={{
            backgroundColor: "rgba(15,23,42,0.10) !important",
          }}
        />
        <SoftTypography
          component="p"
          sx={{
            fontWeight: 500,
            color: "#0F172A",
            fontSize: 16,
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          Player Added Successfully!
        </SoftTypography>
        {/* <SoftTypography
          component="p"
          sx={{
            fontWeight: 500,
            color: "#FFF",
            fontSize: 16,
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          Great news! As you're currently on our free plan, adding players is on
          the house. Enjoy the benefits at no cost!
        </SoftTypography> */}
        <SoftBox
          sx={{
            background: "rgba(15,23,42,0.03)",
            borderRadius: "8px",
            border: "1px solid rgba(15,23,42,0.10)",
            padding: "10px 15px",
            display: "flex",
            marginBottom: "40px",
            gap: "0.5rem",
          }}
        >
          <ReportGmailerrorredIcon sx={{ color: "#475467" }} fontSize="medium" />

          <SoftTypography
            component="p"
            sx={{ fontSize: "14px", fontWeight: 500, color: "#475467" }}
          >
            Please note that any additional players will be charged
            $5 each in the upcoming billing cycle. Thanks for being part of Game My Biz!
          </SoftTypography>
        </SoftBox>
        <SoftBox display="flex" justifyContent="space-between">
          <SoftButton
            color="primary"
            variant="contained"
            onClick={() => navigate("/settings/billing")}
            sx={{
              color: "primary.contrastText",
              textTransform: "none",
              borderRadius: "4px",
            }}
          >
            Go to Billing
          </SoftButton>
          <SoftButton
            color="outlined"
            variant="contained"
            onClick={okayHandler}
            sx={{
              mx: 2,
              textTransform: "none",
              borderRadius: "4px",
              border: "1px solid rgba(15,23,42,0.10)",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
              background: "rgba(15,23,42,0.03)",
              color: "#475467",
              "&:hover": {
                background: "rgba(15,23,42,0.06)",
              },
            }}
          >
            Okay
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </Dialog>
  );
};

export default AddPlayerBillingUpdate;
